module.exports = __webpack_public_path__ + "static/media/loadingSpin.b42a3d6d.gif";